import AntTimeline from 'antd/lib/timeline';

import 'antd/lib/timeline/style/index.css';

export default AntTimeline;
